export default [
  'Name',
  'Empowerment Date',
  'Fiscal Identification Number',
  'Address',
  'Email',
  'Nationality',
];
